module.exports = __webpack_public_path__ + "static/media/success-consents-illus.5182efb0.png";